import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../../providers/AuthProvider';
import { AuthorizedLayout } from '../../components/AuthorizedLayout';
import ButtonPrimary from '../../components/Buttons/ButtonPrimary/ButtonPrimary';
import api from '../../utils/api';
import { getBase64 } from '../../utils/getBase64';
import iconAddPhoto from '../../assets/icon-camera.svg';
import iconTip from '../../assets/icons/iconTip.svg';
import iconHeart from '../../assets/Vector (23).png';
import astronautaHoldingPhone from '../../assets/poses/astronout-holding-phone.svg';
import editIcon from '../../assets/icon-profile-photo.svg';
import './RequiredPhotoUpload.css';

const RequiredPhotoUpload = () => {
  const { user, updateUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const [avatarSrc, setAvatarSrc] = useState(user?.avatar || editIcon);
  const [hasAvatar, setHasAvatar] = useState(!!user?.avatar);

  useEffect(() => {
    if (user?.avatar) {
      setAvatarSrc(user.avatar);
      setHasAvatar(true);
    }
  }, [user?.avatar]);

  const handleImageError = () => {
    if (!user?.avatar) {
      setAvatarSrc(editIcon);
      setHasAvatar(false);
    }
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      toast.error('Por favor, selecione uma imagem válida (JPEG, JPG ou PNG)');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error('A imagem deve ter no máximo 5MB');
      return;
    }

    setUploading(true);

    try {
      const base64Image = await getBase64(file, 350, 350);
      file.base64 = base64Image;
      setAvatarSrc(base64Image);
      setHasAvatar(true);

      const { data } = await api.put(`/talents/talents/${user.id}`, {
        data: {
          attributes: {
            avatar: { data: base64Image },
          },
        },
      });

      if (data) {
        updateUser(data);
        toast.success('Foto do perfil atualizada com sucesso!');
      }
    } catch (error) {
      console.error('Error uploading photo:', error);
      toast.error('Ocorreu um erro ao tentar atualizar sua foto. Tente novamente.');
    } finally {
      setUploading(false);
    }
  };

  const handleContinue = () => {
    if (!hasAvatar && !user?.avatar) {
      toast.error('Adicione uma foto de perfil para continuar');
      return;
    }

    navigate('/home');
  };

  return (
    <>
      <AuthorizedLayout>
        <div className="containerRequiredPhoto">
          <div className="requiredPhotoMainWrapper">
            <div className="requiredPhotoContent">
              <div className="requiredPhotoContentWrapper">
                <div className="welcomeHeader">
                  <div className="welcomeContent">
                    <div className="welcomeText">
                      <h2 className="welcomeTitle">Foto de Perfil</h2>
                      <p className="welcomeDescription">
                        Para começar sua jornada, precisamos de uma foto.
                      </p>
                      <p className="welcomeDescription">
                        Uma boa foto aumenta as chances do seu perfil ser encontrado por empresas!
                      </p>
                    </div>
                    <img
                      src={astronautaHoldingPhone}
                      alt="Astronauta segurando celular"
                      className="welcomeAstronaut"
                    />
                  </div>
                  <div className="welcomeTip">
                    <img src={iconTip} alt="Dica" className="welcomeTipIcon" />
                    <span>Você pode alterar sua foto de perfil quando quiser</span>
                  </div>
                </div>

                <div className="uploadPhotoSection">
                  <div className="containerPhotoProfileRequired">
                    <label className="uploadIconRequired" htmlFor="fuploadRequired">
                      <div style={{ position: "relative" }}>
                        {user.avatar && (
                          <img
                            src={iconAddPhoto}
                            alt="edit"
                            style={{
                              position: "absolute",
                              bottom: "-10px",
                              right: "5px",
                              width: "40px",
                              height: "40px",
                            }}
                          />
                        )}
                        <img
                          src={avatarSrc}
                          alt="edit"
                          className={hasAvatar ? "fotoIconRequired" : "editIconRequired"}
                          htmlFor="fuploadRequired"
                          onError={handleImageError}
                        />
                      </div>

                      <input
                        type="file"
                        id="fuploadRequired"
                        name="fuploadRequired"
                        className="fupload form-control"
                        accept=".jpeg, .png, .jpg"
                        onChange={handleFileSelect}
                        style={{ display: "none" }}
                      />
                    </label>
                  </div>

                </div>

                <div className="requiredPhotoButtonWrapper">
                  <ButtonPrimary
                    text="Continuar"
                    onClick={handleContinue}
                    disabled={uploading || (!hasAvatar && !user?.avatar)}
                    loading={uploading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footerMobileFixed">
          Desenvolvido com
          <img src={iconHeart} alt="" />
          <strong>© eComLovers®</strong>
        </div>
      </AuthorizedLayout>

      {uploading && (
        <div className="globalSpinnerOverlay">
          <div className="spinner" />
        </div>
      )}
    </>
  );
};

export default RequiredPhotoUpload;
